<div class="navbar bg-dark-blue mt-2">
  <div class="container linkNoUnderline">
    <div class="row w-100px d-flex flex-wrap">
      <div class="col-12 col-md-3 d-flex flex-column">

        <div class="d-flex">
          <a class="navbar-brand" routerLink="/" aria-label="Sage Indonesia home">
            <img src="/assets/img/sage-logo.svg" width="78" height="30" alt="Sage Logo" />
          </a>
        </div>

      </div>
      <div class="col-12 col-md-3 text-top pt-3 d-flex flex-column">
        <div class="text-white mb-3">
          <div class="small fw-bolder text-secondary p-1">Products</div>
          <div class="small fw-bold p-1"><a routerLink="/products/sage300" class="text-white">Accounting</a></div>
          <div class="small fw-bold p-1"><a routerLink="/products/sagecrm" class="text-white">Customer Relationship Management</a></div>
          <div class="small fw-bold p-1"><a routerLink="/products/hrpay" class="text-white">HR &amp; Payroll </a></div>
        </div>
      </div>
      <div class="col-12 col-md-3 text-top pt-3 d-flex flex-column">
        <div class="text-white mb-3">
          <div class="small fw-bolder text-secondary p-1">Support &amp; Training</div>
          <div class="small fw-bold p-1"><a routerLink="/support" class="text-white">Support</a></div>
          <div class="small fw-bold p-1"><a routerLink="/training" class="text-white">Training</a></div>
          <div class="small fw-bold p-1"><a routerLink="/products/sagecover" class="text-white">Sage Cover</a></div>
        </div>
      </div>
      <div class="col-12 col-md-3 text-top pt-3 d-flex flex-column">
        <div class="text-white mb-3">
          <div class="small fw-bolder text-secondary p-1">Company</div>
          <div class="small fw-bold p-1"><a routerLink="/about-us" class="text-white">About Us</a></div>
          <div class="small fw-bold p-1"><a routerLink="/awards" class="text-white">Awards</a></div>
          <div class="small fw-bold p-1"><a routerLink="/contact-us" class="text-white">Contact Us</a></div>
        </div>
      </div>
      <div class="w-100 text-center mt-2">
        <small class="text-white">Copyright &copy; 2020 Microtek Informa Solusindo - Sage Premier Partner for Indonesia</small>
      </div>
    </div>
  </div>
</div>
